/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { css, jsx } from '@emotion/core'
import { mediaQueries } from '../twd/media-queries'
import React from 'react'

const errorMessageCss = css`
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border: solid 1px #e4e4e4;
    ${mediaQueries.notXs} {
        min-height: 550px;
    }
`

export const ErrorMessage = ({error, subError}) => {
    return <React.Fragment>
        <div className="row vertical-offset-xs">
        <div className="col-xs-12 text-center" css={errorMessageCss}>
        <i className="et-icon et-alert et-icon-md" aria-hidden="true"></i>
        <div className="small-header">{error}</div>
        {subError && <p>{subError}</p>}
        </div>
        </div>
        <div className="row vertical-offset-xs">
        <div className="col-xs-12 text-right text-small">
            Source: FINRA TRACE/MSRB
        </div>
        </div>
    </React.Fragment>
}